export const MOCKTEST_LIST_ALL_REQUEST = "MOCKTEST_LIST_ALL_REQUEST";
export const MOCKTEST_LIST_ALL_SUCCESS = "MOCKTEST_LIST_ALL_SUCCESS";
export const MOCKTEST_LIST_ALL_FAIL = "MOCKTEST_LIST_ALL_FAIL";

export const MOCKTEST_DETAILS_REQ = "MOCKTEST_DETAILS_REQ";
export const MOCKTEST_DETAILS_SUCCESS = "MOCKTEST_DETAILS_SUCCESS";
export const MOCKTEST_DETAILS_FAILED = "MOCKTEST_DETAILS_FAILED";
